export const MIN_VOLUME_VALUE = 0;
export const MED_VOLUME_VALUE = 0.5;
export const MAX_VOLUME_VALUE = 1;
export const INIT_VOLUME_VALUE = 0.8;
